<script>
  import { VueMaskDirective as mask } from 'v-mask'
  import ClickOut from '../../../../../utils/directives/clickout'
  import UnidadePolicialService from '../../../../../domain/policia-civil/unidade-policial/services/unidade-policial'
  import UPagination from '../../../../_default/components/Uloc/Pagination'
  import { forEach as _forEach, debounce } from 'lodash'

  export default {
    components: {
      UPagination
    },
    name: 'UnidadePolicial',
    directives: {mask, ClickOut},
    data () {
      return {
        openCFilter: false,
        showFiltros: false,
        isLoading: false,
        data: null,
        paginationLimits: [25, 50, 100],
        pagination: {
          totalPages: 0,
          totalItems: 0,
          atualPage: 1,
          limit: 25
        },
        checkeds: 0,
        checkedAll: false,
        filtros: {
          busca: ''
        },
        filterKey: '',
        sortKey: '',
        tiposPessoa: [
          {label: 'Ambos', value: '', class: 'btn-default'},
          {label: 'Física', value: 1, class: 'btn-default'},
          {label: 'Jurídica', value: 2, class: 'btn-default'}
        ],
        sortOrders: {
          'numero': 1,
          'titulo': 1,
          'comitente': 1
        },
        prevent: {},
        dblclick: 0
      }
    },
    filters: {
      capitalize: function (str) {
        return str.charAt(0).toUpperCase() + str.slice(1)
      }
    },
    computed: {
      filteredData: function () {
        let sortKey = this.sortKey
        let filterKey = this.filterKey && this.filterKey.toLowerCase()
        let order = this.sortOrders[sortKey] || 1
        let data = this.data
        if (filterKey) {
          data = data.filter(function (row) {
            return Object.keys(row).some(function (key) {
              return String(row[key]).toLowerCase().indexOf(filterKey) > -1
            })
          })
        }
        if (sortKey) {
          data = data.slice().sort(function (a, b) {
            a = a[sortKey]
            b = b[sortKey]
            return (a === b ? 0 : a > b ? 1 : -1) * order
          })
        }
        return data
      },
      noData () {
        let data = 'data'
        if (this[data] === null) {
          return false
        }
        return this[data].length === 0
      }
    },
    mounted () {
      this.load(this.pagination.limit, this.pagination.atualPage, this.montaFiltros())
    },
    activated () {
    },
    methods: {
      reload () {
        this.load(this.pagination.limit, this.pagination.atualPage, this.montaFiltros())
      },
      loading (v) {
        this.isLoading = !!v
      },

      nextElement ({target}) {
        let index = parseInt(target.getAttribute('tabindex'))
        let next = index + 1
        document.querySelector('[tabindex="' + next + '"').focus()
      },
      open (id) {
        this.$router.push({name: 'policiacivil.policia.unidade-policial.edit', params: {id: id}})
      },

      load (limit, page, filtros) {
        this.data = null
        this.isLoading = true
        UnidadePolicialService.list(limit, page, filtros)
          .then((response) => {
            this.isLoading = false
            console.log(response.data)
            this.data = response.data.result
            this.pagination.atualPage = response.data.offset
            this.pagination.totalPages = response.data.totalPages
            this.pagination.totalItems = response.data.total
          })
          .catch((response) => {
            this.isLoading = false
            console.log(response)
          })
      },

      changePage (page) {
        console.log('Change page ', page)
        this.pagination.atualPage = page
        this.load(this.pagination.limit, page, this.montaFiltros())
      },

      checkAll (o) { /* TODO: Refact / Reuse CheckALL */
        this.$nextTick(() => {
          let ca = this.checkedAll
          let _vm = this
          console.log(ca)
          if (ca === true) {
            console.log(ca, o.length)
            this.checkeds = o.length
          } else {
            this.checkeds = 0
          }
          _forEach(o, (item, key) => {
            _vm.$set(this.data, key, Object.assign({}, this.data[key], {selected: ca})) // Analisar desempenho
            // item.selected = ca
            // console.log(item)
          })
        })
      },
      lazyCheck: function (l) {
        this.$nextTick(() => {
          if (l.selected) {
            this.checkeds += 1
          } else {
            this.checkeds += -1
          }
          this.checkedAll = this.checkeds < this.data.length
        })
      },

      montaFiltros () {
        let filtros = this.filtros
        let mount = ''
        // Busca
        if (filtros.busca.length > 0) {
          mount += '&busca=' + filtros.busca
        }
        return mount
      },
      deletar () {
        var r = confirm('Tem certeza que deseja deletar este policial?')
        if (r) {
          var toDelete = document.getElementsByName('post[]')
          // var list = toDelete.childNodes
          toDelete.forEach(
            function (currentValue, currentIndex, listObj) {
              if (currentValue.checked) {
                UnidadePolicialService.delete(currentValue.value)
                  .then((response) => {
                    this.$loaderOverlay.hide()
                    alert('Policial deletado com sucesso')
                  })
                  .catch((response) => {
                    this.$loaderOverlay.hide()
                    alert('Erro ao deletar policial')
                    alert(response.data.errors)
                    console.log(response)
                  })
              }
            })
          this.reload()
        }

        return
      },

      pesquisar: debounce(function () { // debounce para evitar fazer mais de uma requisição no key event
        let busca = this.filtros.busca
        if (this.prevent.busca === busca) {
          return
        } // previne a repetição de uma chamada de api
        this.prevent.busca = busca
        this.pagination.atualPage = 1
        this.load(this.pagination.limit, this.pagination.atualPage, this.montaFiltros())
      }, 500)
    }
  }
</script>

<template>
  <transition name="slide" appear>
    <div class="app-content-body fade-in-up content-transition">
      <div class="hbox hbox-auto-xs hbox-auto-sm">
        <div class="col">
          <div class="r">

            <div class="bg-light lter b-b wrapper-md">
              <div class="row">
                <div class="col-sm-6 col-xs-12">
                  <h1 class="font-thin h3">
                    Unidade Policial <span class="badge">{{pagination.totalItems}}</span>
                  </h1>
                  <small class="text-muted">
                    <!--<ordenar-arrematante></ordenar-leilao>-->
                  </small>
                </div>
                <div class="col-sm-6 col-xs-12">
                  <div class="text-right text-left-xs">

                    <router-link :to="{name: 'policiacivil.policia.unidade-policial.novo'}" tag="button" class="btn btn-default btn-sm "><i
                      class="fa fa-plus"></i>
                      Nova unidade policial
                    </router-link>

                  </div>
                </div>
              </div>
            </div>

            <div class="panel panel-default">
              <div class="wrapper clearfix">
                <div class="col-sm-7 m-b-xs">
                  <div class="btn-group dropdown">
                    <button type="button" class="btn btn-sm btn-default" disabled data-toggle="dropdown">
                      Exportar
                      <span class="caret"></span>
                    </button>
                    <ul class="dropdown-menu">
                      <li><a href="">Dropdown link</a></li>
                      <li><a href="">Dropdown link</a></li>
                      <li><a href="">Dropdown link</a></li>
                    </ul>
                  </div>
                  <button class="btn btn-sm btn-default" aria-disabled="true"  @click="deletar()" >Deletar
                  </button>
                </div>
                <div class="col-sm-5">
                  <div class="input-group">
                    <input type="text" class="input-sm form-control" v-model="filtros.busca" @keyup="pesquisar"
                           placeholder="Pesquisar">
                    <span class="input-group-btn">
                                <button class="btn btn-sm btn-default" type="button">Buscar</button>
                            </span>
                  </div>
                </div>
              </div>
              <!--<div class="wrapper m-b-n m-t-n text-right">
                <u-pagination @changePage="changePage" :atual="pagination.atualPage"
                              :total="pagination.totalPages"></u-pagination>
              </div>-->

              <div class="table-responsive">
                <table class="table table-hover table-striped b-t b-light">
                  <thead>
                  <tr>
                    <th style="width:20px;">
                      <label class="i-checks m-b-none">
                        <input type="checkbox" @change="checkAll(data)" v-model="checkedAll" tabindex="0"
                               aria-checked="false"
                               aria-invalid="false"><i></i>
                      </label>
                    </th>
                    <th>Nome</th>
                    <th>Matricula</th>
                  </tr>
                  </thead>
                  <tbody>
                  <!-- FAKE -->
                  <tr v-if="isLoading" v-for="i in [1,2,3]">
                    <td class="v-middle">
                      <u-fake-loader width="20px" class="m-t"></u-fake-loader>
                    </td>
                    <td role="button" tabindex="0">
                      <u-fake-loader width="100%" class="m-t"></u-fake-loader>
                    </td>
                  </tr>
                  <!-- ngRepeat: pessoa in pessoas| limitTo: 10 -->
                  <tr v-for="UnidadePolicial in filteredData">
                    <td class="v-middle">
                      <label class="i-checks m-b-none">
                        <input v-on:click.stop="lazyCheck(UnidadePolicial)"
                           type="checkbox"
                           name="post[]"
                           v-model="UnidadePolicial.selected"
                           tabindex="0" aria-checked="false"
                           aria-invalid="false"
                           :value="UnidadePolicial.id">
                        <i></i>
                      </label>
                    </td>
                    <td @click="open(UnidadePolicial.id)" role="button" tabindex="0">
                      <a class="text-cap custom-link ">{{ UnidadePolicial.nome }}</a>
                    </td>
                    <td @click="open(UnidadePolicial.id)" role="button" tabindex="0">
                      <a class="text-cap custom-link ">{{ UnidadePolicial.matricula }}</a>
                    </td>
                  </tr><!-- end ngRepeat: pessoa in pessoas| limitTo: 10 -->

                  <tr v-if="!filteredData || filteredData.length === 0">
                    <td colspan="6">Nenhum registro encontrado</td>
                  </tr>

                  </tbody>
                </table>
              </div>
              <footer class="panel-footer">
                <div class="row">
                  <div class="col-sm-4 hidden-xs">
                    Mostrar:
                    <select @change="changePage(1)" v-model="pagination.limit"
                            class="input-sm form-control w-auto inline v-middle">
                      <option v-for="p in paginationLimits" :value="p">{{ p }}</option>
                    </select>
                    por página
                  </div>
                  <div class="col-sm-2 text-center">
                    <small class="text-muted inline m-t-sm m-b-sm ">{{ pagination.atualPage }} / {{
                      pagination.totalPages
                      }}
                    </small>
                  </div>
                  <div class="col-sm-6 text-right text-center-xs">
                    <u-pagination @changePage="changePage" :atual="pagination.atualPage"
                                  :total="pagination.totalPages"></u-pagination>
                  </div>
                </div>
              </footer>
            </div>

          </div>
        </div>
        <!-- /.col -->
      </div>
    </div>
  </transition>
</template>



// WEBPACK FOOTER //
// UnidadePolicial.vue?7f5f81e2